import React, { ReactElement } from "react";
import List from "@mui/material/List";
import {
  BudgetMenu,
  ClimateMenu,
  DeveloperMenu,
  DocumentMenu,
  EnergyContractsMenu,
  EnergyMenu,
  LogoutMenu,
  MyAccountMenu,
  PartnerMenu,
  PointOfContactsMenu,
  ProcurementMenu,
  StatementMenu,
  SupportMenu,
  SystemMenu,
} from "./";
import { RootState, useAppSelector } from "@/app/store";

/**
 * LeftMenu component renders the left side menu of the application.
 */
export const LeftMenu = (): ReactElement => {
  const user = useAppSelector((state: RootState) => state?.auth?.user);

  return (
    <List
      sx={{
        px: 1,
        width: "100%",
      }}
    >
      <EnergyMenu />
      <ClimateMenu />
      <ProcurementMenu />
      <BudgetMenu />
      <DocumentMenu />
      <EnergyContractsMenu />
      <PointOfContactsMenu user={user} />
      <PartnerMenu user={user} />
      <StatementMenu />
      <SystemMenu user={user} />
      <SupportMenu />
      <DeveloperMenu />
      <MyAccountMenu />
      <LogoutMenu />
    </List>
  );
};
